import ValueX from '../types/ValueX';

export default class ServicedX extends ValueX {
    static __className = 'ServicedX';

    constructor(constructJson) {
        super(constructJson, 'serviced', 'ServicedX');
    }
}
